export default {
  form: {
    details: {
      title: "Détails du Questionnaire",
      name: "Nom du questionnaire",
      namePlaceholder: "Entrez le nom du questionnaire",
      tag: "Tag",
      collectors: "Sélectionner les enquêteurs",
      selectedCollectors: "Enquêteurs sélectionnés",
      description: "Description",
      descriptionPlaceholder: "Entrez une description",
      titleManagement: "Gestion des Sections",
      pageTitle: "Titre de la page",
      hintUser: "Indice pour l'utilisateur",
      page: "Page",
      label: "Label",
      hint: "Hint",
      relation: "Relation",
      titleField: "Titre",
      after: "Après",
      formContent :"Contenu du questionnaire",
      selectWidget: "Sélectionner un widget",
    },
    tags: {
      empty: " ",
      Prévision_de_la_demande: "Prévision de la demande",
      Adressage_client: "Adressage client",
      Géolocalisation: "Géolocalisation",
      Contrat: "Contrat",
      Absence: "Absence",
    },
    settings: {
      allowMapGps: "Autoriser la prise de la position GPS avec la carte",
      allowGalleryPicture: "Autoriser l’ajout de photo depuis la galerie",
      allowBeforeAnswer: "Autoriser la récupération des réponses de l'enquête précédente",
      allowGetPosLastSurvey: "Autoriser la récupération des anciennes positions d'enquête pour faire un suivis"
    },
    index: {
      deleteTitle: "Supprimer",
      deleteBody: "Êtes-vous sûr de vouloir supprimer ce formulaire ? (Les enquêtes qui sont liées à ce questionnaire seront supprimées)",
      confirmTitle: "Confirmer",
      saveBody: "Enregistrer sous :",
      importBody: "Déposer le fichier à importer :",
      enterName: "Entrez un nom",
      noForm: "Aucun formulaire",
      tagFilter: "Tag des questionnaires",
      all: "Tous",
      dateFrom: "Date de",
      dateTo: "à",
      table: {
        name: "Nom du questionnaire",
        status: "Statut",
        updatedAt: "Modification",
        tag: "Tag",
        nbEnquetes: "Nb Enquêtes"
      },
      inactive: "Inactif",
      active: "Actif",
      activate: "Activer le questionnaire",
      deactivate: "Désactiver le questionnaire",
      unlock: "Déverrouiller",
      lock: "Verrouiller",
      detail: "Voir les détails",
      enquetes: "Voir les enquêtes",
      exportXLS: "Exporter XLSForm",
      duplicateXLS: "Dupliquer"
    },
    widget: {
      calcul: "Calcul :",
      calculPlaceholder: "Écrivez votre calcul ici...",
      constraintMessage: "Message de contrainte",
      constraints: "Contraintes",
      decimal: "Decimal",
      delete: "Supprimer",
      imageTitle: "Titre de l'image",
      interval: "Intervalle",
      lengthMinMax: "Longueur Min/Max",
      min: "Min",
      max: "Max",
      mode: "Mode de saisie",
      notePlaceholder: "Écrivez votre message ici...",
      noteToKnow: "Note à savoir :",
      noteTitle: "Titre de la note",
      possibleAnswer: "Réponse possible",
      question: "Question",
      regex: "Regex",
      regexPlaceholder: "Ex: [A-Za-z0-9]",
      response: "Réponse",
      responseType: "Type de réponse",
      default: "Default",
      defaultValue: "Valeur par défaut",
      value: "Valeur",
      operator: "Opérateur",
      geolocationTitle: "Titre du geolocalisation",
      hint: "Indice",
      position: "Position",
      editQuestion: "Modifier la question",
      editQuestionTitle: "Cliquer pour éditer la question",
      startQuestionTitle: "Début de la question",
      requis: "Requis",
      page: "Page",
      pagePlaceholder: "Saisir la page",
      moveUpTitle: "Déplacer vers le haut",
      moveUp: "Déplacer vers le haut",
      moveDown: "Déplacer vers le bas",
      moveDownTitle: "Déplacer vers le bas",
      deleteTitle: "Supprimer la question",
      settingTitle: "Paramètres du questionnaire",
      pertinence: "Pertinence",
      strictInferieurA: "Strict inférieur à",
      inferieurEgalA: "Inférieur / égal à",
      egalA: "Égal à",
      superieurEgalA: "Supérieur / égal à",
      strictSuperieurA: "Strict supérieur à",
      reponse: "Réponse",
      entierPositif: "Entier positif",
      siLaReponseEst: "Si la réponse est",
      reponses: "Réponses",
      incluses: "Incluses",
      excluses: "Excluses",
      repetition: "Répétition",
      definirRepetition: "Définir une répétition",
      modifierRepetition: "Modifier la répétition",
      utiliserValeurFixe: "Utiliser une valeur fixe",
      utiliserCalcul: "Utiliser un calcul",
      fois: "fois",
      actif: "Actif",
      chooseAppearance: "Choisir une apparence",
      chooseAppearanceAttribute: "Choisir un attribut d'apparence",
      dateType: "Date",
      enableConstraints: "Activer les contraintes",
      loadingPreviousWidgets: "Chargement des widgets précédents...",
      loadingNextWidgets: "Chargement des widgets suivants..."
    },
    enquete: {
      title: "Résultats des {count} enquêtes de : {formName}",
      modal: {
        responsesTitle: "Réponses de l'enquête #{id}",
        dispatchTitle: "Définir le traitement des réponses - Table de paramétrage",
        deleteTitle: "Supprimer",
        deleteBody: "Êtes-vous sûr de vouloir supprimer cette enquête ?"
      },
      table: {
        id: "id",
        question: "question",
        response: "réponse",
        headers: {
          number: "#",
          enqueteId: "ID enquête",
          date: "Date",
          location: "Localisation",
          name: "Nom",
          firstname: "Prénom",
          email: "Email",
          actions: "Actions"
        },
        noData: "Aucune enquête trouvée."
      },
      buttons: {
        close: "Fermer",
        delete: "Supprimer",
        send: "Envoyer les réponses",
        sending: "Envoi en cours...",
        export: "Exporter Excel",
        dispatch: "Traitement Réponses",
        seeResponses: "Voir réponses",
        clear: "Effacer"
      },
      filters: {
        searchPlaceholder: "Rechercher id, nom, prénom, email...",
        dateFrom: "Date de :",
        dateTo: "à :"
      },
      mapping: {
        title: "Associer des champs aux questions",
        fieldQuestion: "Question associée",
        chooseQuestion: "Choisir une question",
        tabs: {
          client: "Client",
          placeCompteur: "Place du compteur",
          compteur: "Compteur",
          meter: "Compteur",
          actif: "Actif",
        },
        fields: {
          customer: {
            nom: "Nom",
            prenom: "Prénom",
            tel_1: "Téléphone 1",
            tel_2: "Téléphone 2",
            raisonSocial: "Raison sociale",
            nomSignature: "Nom de la signature",
            signature: "Signature",
            isValide: "Valide",
            isActive: "Actif"
          },
          placeCompteur: {
            villagesNeighborhood: "Village/Quartier",
            posGPS: "Position GPS"
          },
          compteur: {
            compteur: "Compteur"
          }
        }
      }
    },
  },
}
